"use strict";

angular.module("core")
.component("creditCardIcon", {
    bindings: {
        cardType: "<?"
    },
    templateUrl: require("./credit-card-icon.component.html"),
    controllerAs: 'creditCardIconCtrl',
    controller: function($scope) {
        var cardTypeMapping = {
            'visa': 'fa-brands fa-cc-visa',
            'mastercard': 'fa-brands fa-cc-mastercard',
            'amex': 'fa-brands fa-cc-amex',
            'discover': 'fa-brands fa-cc-discover',
        };

        this.getIconClass = function() {
            if (cardTypeMapping.hasOwnProperty(this.cardType)) {
                return cardTypeMapping[this.cardType];
            }
             return "fas fa-credit-card";
        };
    }
});



//////////////////
// WEBPACK FOOTER
// ./core/payment-methods/credit-card-icon.component.js
// module id = 642
// module chunks = 0